import Vue from 'vue'
import Vuex from 'vuex'
import VueMoment from 'vue-moment'
import moment from 'moment'
import { createVuexLoader } from 'vuex-loading'

const VuexLoading = createVuexLoader({
  moduleName: 'loading',
  componentName: 'v-loading',
  className: 'v-loading'
})

Vue.use(Vuex)
Vue.use(VuexLoading)
Vue.use(VueMoment)

export default new Vuex.Store({
  plugins: [VuexLoading.Store],
  state: {
    client: null,
    user: null,
    session: null,
    userAuthenticated: null,
    clientAuthenticated: null
  },
  mutations: {
    SET_CLIENT_AUTHENTICATION (state, client) {
      state.client = client
      state.clientAuthenticated = true
    },
    CLEAR_CLIENT_AUTHENTICATION (state) {
      state.client = null
      state.clientAuthenticated = false
    },
    SET_USER_SESSION (state, session) {
      state.user = session.user
      state.session = session
      state.userAuthenticated = true
    },
    CLEAR_USER_SESSION (state) {
      state.userAuthenticated = false
      state.user = null
      state.session = null
    }
  },
  getters: {
  },
  actions: {
    authenticate ({ commit, dispatch }, data) {
      return new Promise((resolve, reject) => {
        Vue.http.post(process.env.API_URL + '/user-session', {
          username: data.username,
          code: data.code
        }, {withCredentials: true}).then(response => {
          let session = response.body

          session.expiresAfter = moment().add(moment.duration(session.expiresIn))
          delete session.expiresIn

          setTimeout(() => { dispatch('refreshAuthentication').then(() => {}, () => {}) }, session.expiresAfter.diff(moment()) + 1000)

          commit('SET_USER_SESSION', session)
          resolve()
        }, response => {
          commit('CLEAR_USER_SESSION')
          reject(response.body.errors)
        })
      })
    },
    refreshAuthentication ({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        Vue.http.get(process.env.API_URL + '/user-session', {withCredentials: true}).then(response => {
          let session = response.body

          session.expiresAfter = moment().add(moment.duration(session.expiresIn))
          delete session.expiresIn

          setTimeout(() => { dispatch('refreshAuthentication').then(() => {}, () => {}) }, session.expiresAfter.diff(moment()) + 1000)

          commit('SET_USER_SESSION', session)
          resolve()
        }, response => {
          commit('CLEAR_USER_SESSION')
          reject(response.body.errors)
        })
      })
    },
    refreshClientAuthentication ({ commit }) {
      return new Promise((resolve, reject) => {
        Vue.http.get(process.env.API_URL + '/scanner-client', {withCredentials: true}).then(response => {
          let data = response.body

          if (data.status === 'client_found') {
            commit('SET_CLIENT_AUTHENTICATION', data.client)
            resolve()
          } else {
            commit('CLEAR_CLIENT_AUTHENTICATION')
            reject([data.status])
          }
        }, response => {
          commit('CLEAR_CLIENT_AUTHENTICATION')
          reject(response.body.errors)
        })
      })
    }
  }
})



// WEBPACK FOOTER //
// ./src/vuex/store.js